import React from 'react';
import animation from '../animations/transformer.json';
import TransformationsCount from '../components/transformer/TransformationsCount';
import LottieAnimation from '../components/LottieAnimation';

function TransformationsCounterPage() {
    return (
        <div className="flex flex-wrap overflow-hidden rounded-md">
            <div className="flex flex-wrap content-center justify-center w-2/5 py-12 bg-concrete-dark">
                <TransformationsCount />
            </div>
            <div className="flex justify-center w-3/5">
                <LottieAnimation animation={animation} />
            </div>
        </div>
    );
}

export default TransformationsCounterPage;
